<template>
  <div id="app">
    <Header />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
export default {
  name: "app",
  components: {
    Header,
    Footer,
  },
};
</script>

<style scoped>
#app {
  background-color: #007bff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>

<style>
.page {
  font-size: 26pt;
}
.centered-box {
  width: 85%;
  text-align: center;
}
.locations-white {
  background: rgba(255, 255, 255, 0.8);
  border: 1px black solid;
  color: black;
}
.locations-title {
  font-size: 28px;
  text-transform: uppercase;
  font-weight: 300;
  text-align: center;
}
</style>
